<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4><strong>FINANCIAL MANAGEMENT</strong></h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Recieved Non-Salary Operating Funding From State/Local Government
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Alt Funding From Dev/Partners/NGO
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Alt Funding From Registrations
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Bank Accounts
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Reciept Books
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_fin_tool_has_reciept_books" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Cash Books
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_fin_tool_has_cash_books" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Payment Vouchers
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_fin_tool_has_payment_voucher" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Staff Member Responsible For Financial Acounting
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//CONSTS
//########################################

const FINANCIAL_TOOLS_AVAIL_OPTIONS={
    receipt_books:"receipt_books",
    cash_books:"cash_books",
    payment_voucher:"payment_voucher"
}

//global var
var glo_field_financial_tools_avail=undefined

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary6',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/OpFunds0001/fin30"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/OpFunds0001/fin33"];
        },
        data_qst_3:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/OpFunds0001/fin33"];
        },
        data_qst_4:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/OpFunds0001/fin39"];
        },
        data_qst_5:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/fin13"];
        },
        /**
         * extrapolate the financial tools available data into a global var
         */
        data_fin_tools_avil:function()
        {
            glo_field_financial_tools_avail=this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["surv_start/FinancSys01/FinancBk01/fina"];
            return glo_field_financial_tools_avail
        },
        data_qst_fin_tool_has_reciept_books:function()
        {
            if(glo_field_financial_tools_avail == undefined)
            {
                return {selected_options:[{value:"0"}]};
            }
            else
            {
                let found_selected=glo_field_financial_tools_avail.selected_options.filter(
                    function(option)
                    {
                        if(option.value==FINANCIAL_TOOLS_AVAIL_OPTIONS.receipt_books)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                );
                if(found_selected.length==0)
                {
                    return {selected_options:[{value:"0"}]};
                }
                else
                {
                    return {selected_options:[{value:"1"}]};
                }
            }
        },
        data_qst_fin_tool_has_cash_books:function()
        {
            if(glo_field_financial_tools_avail == undefined)
            {
                return {selected_options:[{value:"0"}]};
            }
            else
            {
                let found_selected=glo_field_financial_tools_avail.selected_options.filter(
                    function(option)
                    {
                        if(option.value==FINANCIAL_TOOLS_AVAIL_OPTIONS.cash_books)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                );
                if(found_selected.length==0)
                {
                    return {selected_options:[{value:"0"}]};
                }
                else
                {
                    return {selected_options:[{value:"1"}]};
                }
            }
        },
        data_qst_fin_tool_has_payment_voucher:function()
        {
            if(glo_field_financial_tools_avail == undefined)
            {
                return {selected_options:[{value:"0"}]};
            }
            else
            {
                let found_selected=glo_field_financial_tools_avail.selected_options.filter(
                    function(option)
                    {
                        if(option.value==FINANCIAL_TOOLS_AVAIL_OPTIONS.payment_voucher)
                        {
                            return true
                        }
                        else
                        {
                            return false
                        }
                    }
                );
                if(found_selected.length==0)
                {
                    return {selected_options:[{value:"0"}]};
                }
                else
                {
                    return {selected_options:[{value:"1"}]};
                }
            }
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
